/** Current operating system. */
export enum OS {
  Mac = 'mac',
  Windows = 'windows',
  Linux = 'linux',
  Unknown = 'unknown',
}

export const getOS = (userAgent: string = window.navigator.userAgent): OS => {
  const ua = String(userAgent).toLowerCase();

  if (ua.includes('macintosh')) {
    return OS.Mac;
  }

  if (ua.includes('windows')) {
    return OS.Windows;
  }

  if (ua.includes('linux') && !ua.includes('android')) {
    return OS.Linux;
  }

  return OS.Unknown;
};
